module.exports = __webpack_public_path__ + "static/media/retro-video-game.9721a6b6.svg";